/* Tonum Meta tracking helper for custom /pages/ templates.
   Two jobs, both browser-side:
     1. ViewContent on load (Shopify never emits product_viewed on page templates)
     2. AddToCart on a successful Cart AJAX add
   Both are SKIPPED automatically if Shopify's own Web Pixels Manager is running,
   so nothing is double counted once that is healthy again.
   Consent is respected via Shopify's Customer Privacy API. */
(function () {
  var el = document.currentScript || document.querySelector('script[data-tonum-vc]');
  if (!el) return;
  var PIXEL_ID = el.getAttribute('data-pixel');
  if (!PIXEL_ID) return;

  var CURRENCY = el.getAttribute('data-currency') || 'USD';
  var vcPayload = {
    content_name: el.getAttribute('data-name') || document.title,
    content_category: el.getAttribute('data-cat') || '',
    content_type: el.getAttribute('data-ctype') || 'product',
    content_ids: (el.getAttribute('data-ids') || '').split(',').filter(Boolean),
    value: parseFloat(el.getAttribute('data-value') || '0'),
    currency: CURRENCY
  };

  /* If Shopify's web pixel is alive it already sends these. Never double count. */
  function shopifyPixelAlive() {
    try { return typeof window.webPixelsManager !== 'undefined'; } catch (e) { return false; }
  }
  function allowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.marketingAllowed !== 'function') return null;
      return !!cp.marketingAllowed();
    } catch (e) { return null; }
  }
  function eid(p) {
    return p + '-' + PIXEL_ID + '-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  var pixelReady = false;
  function ensurePixel() {
    if (pixelReady) return true;
    if (allowed() !== true) return false;
    pixelReady = true;
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
      n.queue = []; t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    try { fbq('init', PIXEL_ID); } catch (e) { }
    return true;
  }

  /* ---------- 1. ViewContent ---------- */
  var vcFired = false;
  function fireViewContent() {
    if (vcFired || shopifyPixelAlive()) return true;
    if (!ensurePixel()) return false;
    vcFired = true;
    try { fbq('track', 'ViewContent', vcPayload, { eventID: eid('vc') }); } catch (e) { }
    return true;
  }

  /* ---------- 2. AddToCart ---------- */
  function fireAddToCart(items) {
    if (shopifyPixelAlive()) return;
    if (!ensurePixel()) return;
    try {
      var ids = [], value = 0, n = 0;
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (it && it.id) ids.push(String(it.id));
        var q = it && it.quantity ? it.quantity : 1;
        if (it && typeof it.price === 'number') value += (it.price / 100) * q;
        n += q;
      }
      fbq('track', 'AddToCart', {
        content_ids: ids,
        content_type: 'product',
        value: Math.round(value * 100) / 100,
        currency: CURRENCY,
        num_items: n
      }, { eventID: eid('atc') });
    } catch (e) { }
  }
  function handleCartResponse(text) {
    try {
      var j = JSON.parse(text);
      var items = j && j.items ? j.items : (j && j.id ? [j] : null);
      if (items && items.length) fireAddToCart(items);
    } catch (e) { }
  }
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;

  /* wrap fetch, pass everything through untouched */
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) { }
      var p = of.apply(this, arguments);
      try {
        if (CART_ADD.test(url)) {
          p.then(function (res) {
            try { if (res && res.ok) res.clone().text().then(handleCartResponse); } catch (e) { }
          }).catch(function () { });
        }
      } catch (e) { }
      return p;
    };
  }
  /* wrap XHR too - one of the pages deliberately uses raw XHR */
  try {
    var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { this.__tnUrl = String(u); } catch (e) { }
      return oo.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      try {
        var self = this;
        if (CART_ADD.test(self.__tnUrl || '')) {
          self.addEventListener('load', function () {
            try { if (self.status >= 200 && self.status < 300) handleCartResponse(self.responseText); } catch (e) { }
          });
        }
      } catch (e) { }
      return os.apply(this, arguments);
    };
  } catch (e) { }

  /* ---------- consent bootstrap ---------- */
  if (!fireViewContent()) {
    document.addEventListener('visitorConsentCollected', fireViewContent);
    var tries = 0;
    var iv = setInterval(function () {
      if (fireViewContent() || ++tries > 20) clearInterval(iv);
    }, 500);
  }
})();
